// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

/**
 * ActivityLogSelectionBar
 *
 * Header row above the Activity Log list with a "Select All" checkbox on the
 * left and a primary "Delete Selected" button on the right. Renders only when
 * there are filtered items to act on.
 */

import { Button, Checkbox } from '@loa/ui-components';

export type ActivityLogSelectionBarProps = Readonly<{
  allSelected: boolean;
  selectedCount: number;
  onSelectAllChange: (checked: boolean) => void;
  onDeleteSelected: () => void;
  disabled?: boolean;
}>;

export function ActivityLogSelectionBar({
  allSelected,
  selectedCount,
  onSelectAllChange,
  onDeleteSelected,
  disabled = false,
}: ActivityLogSelectionBarProps) {
  return (
    <div
      className="activity-log__selection-bar"
      role="toolbar"
      aria-label="Activity log bulk actions"
    >
      <Checkbox
        checked={allSelected}
        onChange={(e) => onSelectAllChange(e.target.checked)}
        disabled={disabled}
        label="Select All"
        aria-label="Select all activity items"
      />
      <Button
        variant="filled"
        colour="purple"
        size="lg"
        onClick={onDeleteSelected}
        disabled={disabled || selectedCount === 0}
        aria-label={`Delete ${selectedCount} selected activity ${selectedCount === 1 ? 'item' : 'items'}`}
      >
        Delete Selected
      </Button>
    </div>
  );
}

export default ActivityLogSelectionBar;
